import Input from './Input';
export default Input;



//////////////////
// WEBPACK FOOTER
// ./src/components/forms/Input/index.tsx
// module id = 542
// module chunks = 0